import AirBnBCarouselContainer from '../../../../components/containers/AirBnBCarouselContainer';
import deepmerge from '../../../utils/deepmerge';
import preloadCustomProps from '../../../utils/preloads/preloadCarouselListings';

const cmpConfig = {
  name: 'listings-carousel',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  version: 'NO_NEEDED',
  containerConfig: {
    settings: {
      instance: AirBnBCarouselContainer
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
